module.exports = __webpack_public_path__ + "logo-fe5141d38a25f50068b4c69b77ca1ec8.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/logo.svg
// module id = 190
// module chunks = 65